
export const questions = {
  "1. sample 1": [
    // Add questions here
  ],
  "2. sample 2": [
    // Add questions here
  ]
};
